import store from 'Shared/store'
import { Provider } from 'react-redux'
import Menu from './Menu'
import ShareButton from 'AccessControl/components/ShareButton'

function startText(campaignType) {
  if (campaignType === 'phone') return 'Start calling'
  if (campaignType === 'sms_conversations') return 'Start replying'

  return ''
}

export default function CampaignActions({ id, campaignType, slug, status, permission }) {
  const isShareCampaign = _.includes(['phone', 'sms_conversations'], campaignType)
  const showShareButton = permission === 'edit' && isShareCampaign

  return (
    <Provider store={store}>
      <div className="actions">
        { showShareButton && <div style={{ marginRight: "10px" }}><ShareButton entityType="campaign" entityId={id} entityName="Campaign" /></div> }
        <Menu campaignId={id} campaignType={campaignType} slug={slug} permission={permission} />
        {isShareCampaign && (
          <a
            className={`button primary ${status === 'paused' ? 'disabled' : ''}`}
            href={`/campaigns/${slug}`}
          >
            {startText(campaignType)}
          </a>
        )}
      </div>
    </Provider>
  )
}
